export interface ImageData {
  path: string
  alt?: string
  ec?: string
}

export interface ButtonData {
  text: string
  ec?: string
  link?: string
}

export interface CardItem {
  bgColor?: string
  cardImage?: ImageData
  lineEC?: string
  title?: string
  titleEC?: string
  titleTag?: string
  description?: string
  descriptionEC?: string
  date?: string
  text?: string
  textEC?: string
  btns?: ButtonData[]
  btnsWrapperEC?: string
}

export interface CtaSection {
  subTitle?: string
  subTitleEC?: string
  title?: string
  titleEC?: string
  titleTag?: string
  description?: string
  descriptionEC?: string
  btns?: ButtonData[]
}

export interface HeroSection {
  bannerImage: string
}

export interface WorkWithUsSection {
  bannerImage: string
  mobileBannerImage: string
  lineEC?: string
  title: string
  titleEC?: string
  btns?: ButtonData[]
  text?: string
  textEC?: string
}

export interface NewsSection {
  title: string
  titleEC?: string
  description?: string
  descriptionEC?: string
  btn?: ButtonData
  cardItems?: CardItem[]
}

export interface ContactUsSection {
  description: string
  descriptionEC?: string
  btns?: ButtonData[]
}

export interface ShoppingCart {
  heroSection?: HeroSection
  ctaSection?: CtaSection
  breadcrumbs?:any
  iconBoxesData?: any
  details?:any
}

export const shoppingCart: ShoppingCart = {
  heroSection: {
    bannerImage: "poultry-page-bg-image",
  },
  ctaSection: {
    title: `<span class='text-[#FFB200]'>Shopping</span> Cart`,
    titleEC: "text-white",
    titleTag: "h1",
  },
  breadcrumbs: {
    type: "page",
    title: "Shopping Cart",    
},
  iconBoxesData: [
    {
      title: "How to order",
      titleEC: "!text-left",
      description: "Ordering from EggCelent is simple and quick. Call us, send a message, and we will deliver fresh, antibiotic-free eggs right to your door.",
      descriptionEC: "!text-left !max-w-[450px] !text-[20px]",
    },
    {
      title: "Delivery",
      titleEC: "",
      description:
        "We offer delivery for every order placed nearby. Enjoy farm-fresh eggs without extra cost or delay.",
      descriptionEC: "!text-left !max-w-[450px] !text-[20px]",
    },
  ],
  details:['product','price','quantity','subtotal']
}
export const  products=[
      {
        image: {
          path: "products-image-1",
          alt: "products-image-1",
        },
        title: "6 Pack Eggs",
        product_id:'1',
        price: "180",
      },
      {
        image: {
          path: "products-image-2",
          alt: "products-image-2",
        },
        title: "12 Pack Eggs",
        product_id:'2',
        price: "355",
      },
      {
        image: {
          path: "products-image-3",
          alt: "products-image-3",
        },
        title: "Egg Tray",
        product_id:'3',
        price: "895",
      },
]
 
export const checkout={
    heroSection: {
    bannerImage: "poultry-page-bg-image",
  },
  ctaSection: {
    title: `<span class='text-[#FFB200]'>Checkout</span>`,
    titleEC: "text-white",
    titleTag: "h1",
  },
  breadcrumbs: {
    type: "page",
    title: "Checkout",
    category: "Shopping Cart",           
    categoryLink: "/shopping-cart",      
}
}